/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { DisconnectData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    disconnectSettingsInstagram: build.mutation<DisconnectData, void>({
      query: () => ({
        body: undefined,
        method: 'POST',
        url: `/v1/settings/instagram/disconnect`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as disconnectSettingsInstagramApi };
export const { useDisconnectSettingsInstagramMutation } = injectedRtkApi;
